var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0625 12.0312C39.8746 12.0312 41.3438 13.5003 41.3438 15.3125C41.1709 19.665 34.9534 19.6638 34.7812 15.3125C34.7812 13.5003 36.2503 12.0312 38.0625 12.0312ZM51.625 27.5625V8.75C51.625 6.33763 49.6624 4.375 47.25 4.375H8.75C6.33763 4.375 4.375 6.33763 4.375 8.75V28.155L12.4517 20.0783C15.0103 17.5196 19.1737 17.5196 21.7325 20.0783L33.3741 31.72L35.8283 29.2658C38.3871 26.7071 42.5504 26.7071 45.1092 29.2658L55.3594 39.516C55.7695 39.9261 56 40.4826 56 41.0628V47.25C56 52.0747 52.0747 56 47.25 56H8.75C3.92525 56 0 52.0747 0 47.25V8.75C0 3.92525 3.92525 0 8.75 0H47.25C52.0747 0 56 3.92525 56 8.75V27.5625C55.8845 30.4649 51.7395 30.4627 51.625 27.5625ZM4.375 34.3421V47.25C4.375 49.6624 6.33763 51.625 8.75 51.625H47.25C49.6624 51.625 51.625 49.6624 51.625 47.25V41.9689L42.0155 32.3595C41.1627 31.5066 39.7749 31.5066 38.9221 32.3595L28.0955 43.186C27.2414 44.0403 25.8564 44.0403 25.0019 43.186C24.1476 42.3316 24.1477 40.9466 25.0019 40.0924L30.2806 34.8137L18.6387 23.172C17.8245 22.3233 16.3594 22.3233 15.5453 23.172L4.375 34.3421Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -4.5,
    y1: -6,
    x2: 74.5,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9FC87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2557,
    stopColor: "#A7FB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5295,
    stopColor: "#BAFB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7844,
    stopColor: "#74FA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAB9"
  })))));
}

export default __webpack_public_path__ + "images/image-icon.svg";
export { SvgImageIcon as ReactComponent };